export default __webpack_public_path__ + "static/media/plumber.1347edcc.png";